export const commonConfig = {
  label: '通用配置',
  children: [
    {
      label: '主车模型',
      key: 'ref_tree_vehicle_config',
      children: [
        {
          label: '3D模型',
          id: 'vehicle_3d_visible',
        },
      ],
    },
    {
      label: '其他',
      children: [
        {
          label: '虚拟障碍物',
          id: 'obstacle_visible',
        },
      ],
    },
  ],
};

export const topicChannelConfig = {
  label: 'TopicChannel',
  children: [
    {
      label: '',
      key: 'ref_tree_topic_channel_config',
      children: [
        {
          label: '/trackList/fused_track/traffic_sign',
          id: '/trackList/fused_track/traffic_sign',
        },
      ],
    },
    {
      label: '',
      key: 'businessResult/',
      children: [
        {
          label: '施工图层',
          id: '/businessResult/pncBusinessInfosList/constructionAreasList',
        },
        {
          label: '忽略障碍物',
          id: '/businessResult/eraseObstacles',
        },
        {
          label: '忽略区域',
          id: '/businessResult/eraseObstacleAreas',
        },
      ],
    },
  ],
};

export const ganzhiConfig = {
  label: 'ObstacleNegligibleType',
  children: [
    {
      label: '',
      key: 'ref_tree_ganzhi_config',
      children: [
        {
          label: 'unknown',
          id: '/ganzhiConfig/ObstacleNegType/0',
        },
        {
          label: 'neg',
          id: '/ganzhiConfig/ObstacleNegType/1',
        },
        {
          label: 'non_neg',
          id: '/ganzhiConfig/ObstacleNegType/2',
        },
        {
          label: 'soft',
          id: '/ganzhiConfig/ObstacleNegType/3',
        },
        {
          label: 'slowdown',
          id: '/ganzhiConfig/ObstacleNegType/4',
        },

      ],
    },
  ],
};

export const otherConfig = {
  label: '其他配置',
  children: [
    {
      // label: '其他',
      key: 'ref_tree_other_config',
      children: [
        {
          label: '障碍物polygon',
          id: 'polygon_local',
        },
        {
          label: '障碍物标签',
          id: 'obstacl_label_local',
        },
        {
          label: 'ShieldPath',
          id: 'shield_ouput_path_local',
        },
        {
          label: 'GlobalMap',
          id: 'GlobalMap_local',
        },
        {
          label: 'LocalMap',
          id: 'localMap_local',
        },
        {
          label: '虚拟车道',
          id: 'virtualLane_local',
        },
        {
          label: '静态障碍物',
          id: 'obstacl_label_local_static',
        },
        {
          label: '人行横道',
          id: 'cross_walk_local',
        },
        {
          label: 'GPS轨迹线',
          id: 'gps_trajectory_local',
        },
        {
          label: '业务接管区',
          id: 'freeArea_enabled',
        }
      ]
    }
  ]
}

export const initOhterList = [
  'polygon_local',
  'obstacl_label_local',
  'shield_ouput_path_local',
  'GlobalMap_local',
  'localMap_local',
  'virtualLane_local',
  'cross_walk_local',
  'gps_trajectory_local',
  'freeArea_enabled',
];
export const initCommonChecks = [['vehicle_3d_visible'], ['obstacle_visible']];
export const initEraseChannelIds = [
  '/businessResult/eraseObstacles',
  '/businessResult/eraseObstacleAreas',
];